<script>
	export default {
        inject: ['rotatorState'],

        props: {
            id: {
                type: Number,
                required: true,
            }
        },

        render() {
            return this.$scopedSlots.default({
                show: this.show
            });
        },

        computed: {
            show() {
                return this.rotatorState.activeImage === this.id;
            }
        }
    }
</script>
